// removed by extract-text-webpack-plugin
module.exports = {"is-focused":"core__is-focused___24dG-"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/core.scss
// module id = 1274
// module chunks = 1